import React, {useEffect} from 'react'
import _ from 'lodash'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import Autocomplete from '@material-ui/lab/Autocomplete'
import {makeStyles} from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Chip from '@material-ui/core/Chip'
import MenuItem from '@material-ui/core/MenuItem'
import './AddNewFilter.scss'
import {UsersContext} from '../../context/Users'

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: '33.3%',
  },
  formControlCloseSection: {
    margin: theme.spacing(1),
    minWidth: '29%',
  },
  closeButton: {
    backgroundColor: '#d9534f',
    border: '1px solid #d43f3a',
    width: '30px',
    color: '#fff',
    alignSelf: 'flex-end',
    marginTop: '10px',
    borderRadius: '4px',
    fontWeight: '900',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  typeForSearch: {
    minWidth: 564,
  },
}))

export default function AddNewFilter({
  addFilter,
  handleRemoveInput,
  onChange = (e, key, value) => {},
  data,
}) {
  const classes = useStyles()
  const [userTemplate, setUserTemplate] = React.useState('')
  const {userTemplates, getAllUserTemplates} = React.useContext(UsersContext)

  useEffect(() => {
    getAllUserTemplates({query: ''})
  }, [getAllUserTemplates])

  const handleChange = event => {
    if (event.target.name === 'user_template') {
      setUserTemplate(event.target.value)
    }
  }

  const getSelected = val => {
    const data = userTemplates?.templates.filter(template => {
      const intValues = val.fix_value.map(value => parseInt(value))
      return intValues.includes(template.template_id)
    })
    return data
  }

  return (
    <div className="add-new-filter">
      {addFilter.map((val, idx) => {
        return (
          <div key={idx}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="demo-simple-select-outlined-label">User Template</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                defaultValue="User Template"
                name="user_template"
                onChange={handleChange}
                label="User Template"
              >
                <MenuItem value="User Template">User Template</MenuItem>
              </Select>
            </FormControl>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="demo-simple-select-outlined-label">Like / Not Like</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                name="invert_query"
                defaultValue={
                  val?.invert_query === true ? 'true' : val.invert_query === false ? 'false' : ''
                }
                onChange={e =>
                  onChange(e, 'template_filters_attributes', e.target.value, 'invert_query', idx)
                }
                label="User Template"
              >
                <MenuItem value="false">Like</MenuItem>
                <MenuItem value="true">Not Like</MenuItem>
              </Select>
            </FormControl>
            <FormControl variant="outlined" className={classes.formControlCloseSection}>
              <button
                type="button"
                className={classes.closeButton}
                onClick={() => handleRemoveInput(idx, val)}
              >
                X
              </button>
            </FormControl>

            <FormControl variant="outlined" className={classes.typeForSearch}>
              {userTemplates?.templates.length && (
                <Autocomplete
                  className="autoComplete"
                  multiple
                  options={userTemplates?.templates}
                  getOptionLabel={option => option?.template_name}
                  name="selectType"
                  filterSelectedOptions
                  defaultValue={val.fix_value && getSelected(val)}
                  onChange={(e, value) => {
                    const fix_value = value.map(val => {
                      return val.template_id
                    })
                    onChange(e, 'template_filters_attributes', fix_value, 'fix_value', idx)
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Type to Search"
                      placeholder="Type to Search"
                    />
                  )}
                />
              )}
            </FormControl>
          </div>
        )
      })}
    </div>
  )
}
